module.exports = __webpack_public_path__ + "img/close.8af091b4.svg";